<template>
  <vs-row>
    <vs-col>
      <vs-row>
        <vs-col>
          <div class="vx-card__title mb-6"><h4 class="">{{ $t('dashboard.block.leaderboard.title') }}</h4></div>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col>
          <vs-table :data="leaderboard.$hasEmbedded('leaderboard') ? leaderboard.$getEmbedded('leaderboard') : []"
                    :noDataText="$t('dashboard.block.leaderboard.none')">
            <template slot="thead">
            <vs-th>
              {{ $t('dashboard.block.leaderboard.columns.first_name') }}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.leaderboard.columns.last_name') }}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.leaderboard.columns.total_referrals') }}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.leaderboard.columns.accepted_referrals') }}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.leaderboard.columns.acceptance_rate') }}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.leaderboard.columns.expired_referrals') }}
            </vs-th>
            </template>

            <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].firstName">
                {{ data[indextr].firstName}}
              </vs-td>
              <vs-td :data="data[indextr].lastName">
                {{ data[indextr].lastName}}
              </vs-td>
              <vs-td :data="data[indextr].totalReferrals">
                {{ data[indextr].totalReferrals}}
              </vs-td>
              <vs-td :data="data[indextr].acceptedReferrals">
                {{ data[indextr].acceptedReferrals}}
              </vs-td>
              <vs-td :data="data[indextr].acceptanceRate">
                {{ data[indextr].acceptanceRate}}%
              </vs-td>
              <vs-td :data="data[indextr].expiredReferrals">
                {{ data[indextr].expiredReferrals}}
              </vs-td>
            </vs-tr>
            </template>
          </vs-table>
        </vs-col>
        <vs-col class="mt-5">
          <vs-row>
            <vs-col vs-w="6" vs-align="left" vs-justify="left" class="text-left">
              <a v-if="displaySeeMore" style="cursor:pointer;" @click="onSeeMore">
                [+] {{ $t('dashboard.block.leaderboard.buttons.view_more') }}
              </a>
              <a v-if="displaySeeLess" style="cursor:pointer;" @click="onSeeLess">
                [-] {{ $t('dashboard.block.leaderboard.buttons.view_less') }}
              </a>
            </vs-col>
            <vs-col vs-w="6" vs-align="right" vs-justify="right" class="text-right">
              <router-link :to="{name:'app-view-leaderboard'}">{{ $t('dashboard.block.leaderboard.buttons.view_all') }}</router-link>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>
import {ResourceImpl} from 'hal-client';
import SmIntervalButton from '@/components/starling/sm-interval-button/sm-interval-button';

export default {
  name: 'dashboard-leaderboard-list',
  components: {
    SmIntervalButton
  },
  props: {
    leaderboardResource: ResourceImpl
  },
  data () {
    return {
      leaderboard: this.leaderboardResource
    };
  },
  computed: {
    displaySeeMore () {
      return this.leaderboard && this.leaderboard.$hasEmbedded('leaderboard') && this.leaderboard.$hasLink('next') && this.leaderboard.page.size < 20;
    },
    displaySeeLess () {
      return this.leaderboard && this.leaderboard.$hasEmbedded('leaderboard') && this.leaderboard.page.totalElements > 5 && (this.leaderboard.page.size >= 20 || !this.leaderboard.$hasLink('next'));
    }
  },
  methods: {
    onSeeMore () {
      this.leaderboard.$request().$get('search', {size: this.leaderboard.page.size + 5}).then(res => {
        this.leaderboard = res;
      });
    },
    onSeeLess () {
      this.leaderboard.$request().$get('search', {size: 5}).then(res => {
        this.leaderboard = res;
      });
    }
  }
};
</script>
